/* Generate a data-auto attribute for automation */
export const generateDataAuto = (key = '', name = '') => {
  return name != null && typeof name.toLowerCase === 'function'
    ? `${key}_${name.toLowerCase().replace(/ /g, '_')}`
    : '';
};
